import React from 'react';
import { FaFileAlt, FaClipboardCheck, FaShieldAlt } from 'react-icons/fa';
import styles from '../../../styles/Cadastral.module.css';

function Block({ title, icon: Icon, children }) {
  return (
    <div className={styles.block}>
      <div className={styles.blockTitle}>
        <span className={styles.btIco}><Icon size={13} /></span>
        {title}
      </div>
      {children}
    </div>
  );
}

function Dl({ items, singleCol = false }) {
  return (
    <dl className={`${styles.dl} ${singleCol ? styles.one : ''}`}>
      {items.map(([label, val, className = ''], index) => (
        <div key={index}>
          <dt>{label}</dt>
          <dd className={styles[className] || className}>{val}</dd>
        </div>
      ))}
    </dl>
  );
}

export default function LegalTab({ file }) {
  const deed = file.deed;

  const deedDetails = [
    ['Tipo de documento', deed.type],
    ['Número', deed.number, 'mono'],
    ['Volumen', deed.volume, 'mono'],
    ['Fecha del instrumento', deed.date],
    ['Notaría Pública No.', deed.notaryOffice, 'mono'],
    ['Notario', deed.notaryName],
    ['Lugar', deed.location],
    ['Folio Real', deed.realEstateFolio, 'mono']
  ];

  const registryDetails = [
    ['Inscripción en el Registro Público de la Propiedad', deed.publicRegistry]
  ];

  return (
    <div className={styles.tabContentFade}>
      <Block title="Documento que acredita la propiedad" icon={FaFileAlt}>
        <Dl items={deedDetails} />
      </Block>

      <Block title="Antecedente registral" icon={FaClipboardCheck}>
        <Dl items={registryDetails} singleCol />
      </Block>

      <Block title="Fundamento jurídico" icon={FaShieldAlt}>
        <div className={`${styles.stateDetail} ${styles.stateBrand}`}>
          <strong>Artículo 2, fracción VII — Ley de Catastro para el Estado de Querétaro.</strong>
          <br />
          "El código que identifica a un predio de forma única para su localización geográfica, mismo que es asignado a cada
          uno de ellos en el momento de su inscripción en el padrón catastral por la Dirección de Catastro."
        </div>
      </Block>
    </div>
  );
}